import { render, staticRenderFns } from "./clinic.vue?vue&type=template&id=61e55e87&scoped=true&"
import script from "./clinic.vue?vue&type=script&lang=js&"
export * from "./clinic.vue?vue&type=script&lang=js&"
import style0 from "./clinic.vue?vue&type=style&index=0&id=61e55e87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e55e87",
  null
  
)

export default component.exports